module.exports = __webpack_public_path__ + "static/t6-f3c7da6c2daef352179c6a08ed59ebaa.jpg";